<template>
	<div>
		<!-- <el-button type="primary" @click="is_show_search = true" plain>筛选内容</el-button> -->
		<!-- <el-button type="primary" @click="keySearch">搜索</el-button> -->
		<el-button type="primary" plain @click="resetSearch">刷新</el-button>
		<el-button type="primary" @click="handleCreate">添加</el-button>

		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column prop="type_init" label="类型"> </el-table-column>
				<el-table-column prop="account" label="账号"> </el-table-column>
				<el-table-column label="操作" fixed="right">
					<template slot-scope="{row,$index}">
						<el-button type="primary" size="mini" @click="handleUpdate(row)">编辑</el-button>
						<el-popconfirm @confirm="handleDelete(row,$index)" @onConfirm="handleDelete(row,$index)" title="确定删除该数据？">
							<el-button style="margin-left:10px;" type="danger" size="mini" slot="reference">删除
							</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
			<!-- 添加/编辑 -->
			<el-dialog title="设置" width="40%" :visible.sync="is_show_create">
				<span>
					<el-form ref="form" label-width="120px" size="medium">
						<el-form-item label="类型">
							<el-col :span="12">
								<el-radio-group v-model="create_data.type">
									<el-radio label="1">微信</el-radio>
									<el-radio label="2">支付宝</el-radio>
									<el-radio label="3">银行卡</el-radio>
								</el-radio-group>
							</el-col>
						</el-form-item>
						<el-form-item label="账号">
							<el-col :span="12">
								<el-input placeholder="请填写" v-model="create_data.account" clearable> </el-input>
							</el-col>
						</el-form-item>
					</el-form>
				</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_create = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="createData()">确定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		accountList,accountSet,accountDel
	} from '@/api/sign_admin'
	import {
		alertMsg
	} from '@/tool/index'
	import request from '@/tool/request'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	export default {
		components: {
			Pagination
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				is_show_search: false, // 搜索模态框
				data_list: [], // 表格数据
				checkbox_data: [], // 多选的数组
				loading: true,
				is_show_create: false,
				create_data: {}
			};
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},

			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: [],
				}
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			getList() { // 获取列表数据
				this.loading = true;
				accountList(Qs.stringify(this.listQuery)).then(response => {
					this.data_list = response.result.items;
					this.total = response.result.total;
					this.loading = false;
				})
			},
			handleDelete(row, index) { // 数据的删除
				accountDel(Qs.stringify(row)).then(response => {
					this.data_list.splice(index, 1)
					alertMsg(this, '删除成功', 'success');
				})
			},

			resetCreateData() { // 重置create_data数据
				this.create_data = {
					'id': '',
					'type': '1',
					'account': '',
				}
			},
			handleCreate() {
				this.resetCreateData();
				this.is_show_create = !this.is_show_create;
			},
			handleUpdate(row) {
				this.create_data = Object.assign({}, row);
				this.create_data.type = this.create_data.type.toString();
				this.is_show_create = !this.is_show_create;
			},
			createData() {
				this.$store.commit('setAjaxLoading', true);
				accountSet(Qs.stringify(this.create_data)).then(response => {
					this.getList();
					this.is_show_create = !this.is_show_create;
					alertMsg(this, '添加成功', 'success');
				})
			},
		}
	}
</script>
